'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _AddPropertyBlock = require('./AddPropertyBlock');var _AddPropertyBlock2 = _interopRequireDefault(_AddPropertyBlock);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _helpers = require('../PublishNewHomesForm/helpers');

var _AddPropertiesToProject = require('./AddPropertiesToProject.scss');var styles = _interopRequireWildcard(_AddPropertiesToProject);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

AddPropertiesToProject = function (_Component) {_inherits(AddPropertiesToProject, _Component);function AddPropertiesToProject() {var _temp, _this, _ret;_classCallCheck(this, AddPropertiesToProject);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.








    addAssetToDelete = function (_ref) {var publicId = _ref.publicId,contentType = _ref.contentType;
      _this.props.addAssetToDelete({ id: publicId, type: contentType });
    }, _this.

    addImagesToUnsuspend = function (images) {
      (images || []).forEach(function (item) {
        _this.props.addAssetToUnsuspend({
          type: 'image',
          id: item.link });

      });
    }, _this.

    submitForm = function (_ref2) {var propertyBlock = _ref2.propertyBlock;
      if (!propertyBlock || !propertyBlock.length) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/profile/my_projects'));
      }

      if (_this.props.isEditProject) {
        var projectId = _this.props.location.query.id;

        propertyBlock.forEach(function (_ref3)










        {var property_type = _ref3.property_type,name = _ref3.name,summary = _ref3.summary,start_price = _ref3.start_price,exact_price = _ref3.exact_price,rooms = _ref3.rooms,area = _ref3.area,plan_images = _ref3.plan_images,id = _ref3.id,project_id = _ref3.project_id;
          _this.addImagesToUnsuspend(plan_images);

          if (id) {
            return _this.props.editMyPropertyByProject({
              project_id: project_id,
              property_id: id,
              token: _this.props.userToken,
              data: {
                property_type: property_type,
                name: name,
                summary: summary,
                start_price: (0, _helpers.parsePrice)(start_price),
                exact_price: (0, _helpers.parsePrice)(exact_price),
                rooms: rooms,
                area: area,
                plan_images: plan_images,
                is_foreign: _this.props.isForeign } });


          }

          return _this.props.addPropetiesToProject({
            data: {
              property_type: property_type,
              name: name,
              summary: summary,
              start_price: (0, _helpers.parsePrice)(start_price),
              exact_price: (0, _helpers.parsePrice)(exact_price),
              rooms: rooms,
              area: area,
              plan_images: plan_images,
              is_foreign: _this.props.isForeign },

            token: _this.props.userToken,
            id: projectId });

        });
      } else {
        propertyBlock.forEach(function (_ref4)








        {var property_type = _ref4.property_type,name = _ref4.name,summary = _ref4.summary,start_price = _ref4.start_price,exact_price = _ref4.exact_price,rooms = _ref4.rooms,area = _ref4.area,plan_images = _ref4.plan_images;
          _this.addImagesToUnsuspend(plan_images);

          return _this.props.addPropetiesToProject({
            data: {
              property_type: property_type,
              name: name,
              summary: summary,
              start_price: (0, _helpers.parsePrice)(start_price),
              exact_price: (0, _helpers.parsePrice)(exact_price),
              rooms: rooms,
              area: area,
              plan_images: plan_images,
              is_foreign: _this.props.isForeign },

            token: _this.props.userToken,
            id: _this.props.creationNewHomes.data.id });

        });
      }
    }, _this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.submitForm)(evt);
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);}AddPropertiesToProject.prototype.componentWillMount = function componentWillMount() {var projectId = this.props.location.query.id;if (this.props.isEditProject) {this.props.myPropertyByProject({ id: projectId });}};AddPropertiesToProject.prototype.

  render = function render() {var _props =














    this.props,push = _props.array.push,fields = _props.fields,locale = _props.locale,translate = _props.translate,creationNewHomes = _props.creationNewHomes,isRtl = _props.isRtl,isEditProject = _props.isEditProject,initialValues = _props.initialValues,deleteMyPropertyByProject = _props.deleteMyPropertyByProject,userToken = _props.userToken,hideMessageModal = _props.hideMessageModal,openMessageModal = _props.openMessageModal,isForeign = _props.isForeign;

    return (
      _react2.default.createElement('form', null,
        isEditProject && creationNewHomes.loadingByProperty ?
        _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
        _react2.default.createElement(_AddPropertyBlock2.default, {
          push: push,
          name: 'propertyBlock',
          fields: fields,
          locale: locale,
          translate: translate,
          userToken: userToken,
          creationNewHomes: creationNewHomes,
          addAssetToDelete: this.addAssetToDelete,
          isRtl: isRtl,
          changeValue: this.props.changeValue,
          isEditProject: isEditProject,
          hideMessageModal: hideMessageModal,
          openMessageModal: openMessageModal,
          initialValues: initialValues,
          deleteMyPropertyByProject: deleteMyPropertyByProject,
          isForeign: isForeign }),


        _react2.default.createElement('div', { className: styles.submitWrapper },
          _react2.default.createElement('button', { onClick: this.handleSubmit },
            creationNewHomes.loading ?
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
            _react2.default.createElement('span', { className: 'button-text' }, this.props.translate('addNewProject', 'submit'))))));





  };return AddPropertiesToProject;}(_react.Component);


AddPropertiesToProject.propTypes = {
  translate: _propTypes2.default.func,
  editMyPropertyByProject: _propTypes2.default.func,
  myPropertyByProject: _propTypes2.default.func,
  addPropetiesToProject: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  sendContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  handleSubmit: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  addAssetToDelete: _propTypes2.default.func,
  addAssetToUnsuspend: _propTypes2.default.func,
  changeAssetsTags: _propTypes2.default.func,
  fields: _propTypes2.default.object,
  location: _propTypes2.default.object,
  array: _propTypes2.default.object,
  creationNewHomes: _propTypes2.default.object,
  isEditProject: _propTypes2.default.bool,
  changeValue: _propTypes2.default.func,
  deleteMyPropertyByProject: _propTypes2.default.func,
  initialValues: _propTypes2.default.object,
  isForeign: _propTypes2.default.bool };exports.default =


AddPropertiesToProject;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddPropertiesToProjectForm/AddPropertiesToProject.js
// module id = 2943
// module chunks = 0